import { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export function useAxiosInterceptor() {
    const navigate = useNavigate();

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            response => {
                return response;
            },
            error => {
                if (error.response?.status === 401) {
                    localStorage.removeItem('token');
                    navigate('/login', { replace: true });
                }

                return Promise.reject(error);
            }
        );

        return () => axios.interceptors.response.eject(interceptor);
    }, [navigate]);
}
